import {
	useContext,
	useEffect,
	useState
} from "react";

import { Box, Typography } from "@mui/material";
import { ApiContext } from "../ApiContext";
import { BackdropLoading } from "../Common/BackdropLoading";
import { UserContext } from "../UserContext";

import { isMobile } from "react-device-detect";

import { useTranslation } from "react-i18next";
import LandingAnimation from "../../Helpers/LandingAnimation";
import { ColorScheme } from "../../Themes/ColorScheme";
import { KeyManagement } from "../KeyManagement/KeyManagement";
import { DoorList } from "./DoorList";
import { ListGroupingSlider } from "./Services/ListGroupingSlider";
;

export const CalendarComponent = () => {

	const { t } = useTranslation();

	const debug = false;

	const { selectedLocation } = useContext(UserContext);
	const { ApiCall } = useContext(ApiContext);

	const [isLoading, setIsLoading] = useState(true);
	const [selectedService, setSelectedService] = useState(null);
	const [reservableList, setReservableList] = useState([]);

	const getReservables = () => {
		setIsLoading(true);

		ApiCall(
			"GET",
			`client/resident_spaces/${selectedLocation.id}`
		)
			.then((response) => {

				setReservableList(response);
				// Update selectedService if it is not null
				if (selectedService !== null) {
					const foundService = response.find(
						(entry) => entry.id === selectedService.id
					);
					if (foundService) {
						setSelectedService(foundService);
					} else {
						setSelectedService(response[0]);
					}
				} else if (response.length > 0) {
					setSelectedService(response[0]);
				} else {
					setSelectedService(null);
				}
				setIsLoading(false);

			})
			.catch((error) => {
				setIsLoading(false);
			});
	};

	// Child components can refresh reservables by calling this function
	function refreshReservables() {
		getReservables();
	}

	useEffect(() => {
		if (selectedLocation !== null) {
			setIsLoading(true);
			getReservables();
		}
	}, [selectedLocation]);

	return (
		<div
			style={{
				transition: "width 0.2s ease-out",
				paddingBottom: "50px"
			}}
		>
			<div
				style={{
					display: "flex",
					height: "100%",
					minWidth: "100%"
				}}
			>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						width: "100%"
					}}
				>
						{reservableList.length > 0 && (
							<LandingAnimation>
								<ListGroupingSlider
									passSelectedService={setSelectedService}
									selectedService={selectedService}
									reservables={reservableList}
								/>
							</LandingAnimation>
						)}
						{!isLoading && reservableList.length == 0 && <Typography sx={{
							fontSize: "20px",
							fontWeight: "700",
							color: ColorScheme.white,
							textAlign: isMobile ? "center" : undefined
						}}>{t("key_management.no_key_management_spaces")}</Typography>}
					{!isMobile && selectedService?.type === 3 && (
						<DoorList selectedService={selectedService} />
					)}
	
					{selectedService !== null && selectedService?.type === 3 && (
						<LandingAnimation>
							<Box
								sx={{
									display: "flex",
									paddingBottom: "50px",
									width: "100%",
									gap: "10px"
								}}
							>
								<KeyManagement
									refreshReservables={refreshReservables}
									data={selectedService}
								/>
							</Box>
						</LandingAnimation>
					)}
				</div>
			</div>
			{isLoading && <BackdropLoading />}
		</div>
	);
};
